import clsx from "clsx";

interface UserInfoProps {
  nombre?: string;
  className?: string;
}

export const UserInfo = ({
  nombre = "...",
  className,
}: UserInfoProps) => {
  return (
    <div
      className={clsx(
        "hidden text-right text-xs leading-normal text-slate-600 md:block select-none",
        className
      )}
    >
      <p className="font-semibold text-slate-800 tracking-tight">
        {nombre}
      </p>
    </div>
  );
};
